import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import SearchFields from './searchFields';
import { getSafeManagements } from 'actions/EntityActions';
import { formInput, clearFormInput } from 'actions/FormActions';
import { getCsvReport } from 'actions/ReportsAction';
import { mapSafeManagement } from 'utils/mappers';
import { safeManageMentListCrumb } from 'utils/breadcrumbInfo';
import LOOKUP from 'constants/lookup';
// Basic Components
import Grid from 'screens/components/basic/Grid';
import CardSimple from 'screens/components/basic/CardSimple';
import Pagination from 'screens/components/basic/Pagination';
import Button from 'screens/components/basic/Button';
import GenericTable from 'screens/components/advanced/GenericTable';
import PageHeaderWithButton from 'screens/components/basic/PageHeaderWithButton';

const compName = "SafeManagementList";

class SafeManagementList extends Component {
  constructor(props, context) {
    super(props, context)
    this.state = {
      activePage: 1,
      itemsPerPage: 10,
      orderBy: 'DESC',
      sortBy: 'CreatedDate'
    };
  }

  componentDidMount() {
    this.cleanSearch();
  }

  getSafeManagements = (page) => {
    this.props.getSafeManagements({
      branchId: this.props.branchId || 0,
      datefrom: this.props.datefrom || null,
      dateto: this.props.dateto || null,
      type: this.props.type || 0,
      employeeName: this.props.employee || null,
      orderBy: this.state.orderBy,
      sortBy: this.state.sortBy,
      page: page || this.state.activePage,
      itemsPerPage: this.state.itemsPerPage
    });
  }

  addSafeManagement = () => {
    this.props.callSaveView();
  }

  search = () => {
    this.getSafeManagements();
  }

  cleanSearch = () => {
    this.props.clearFormInput(`${compName}DateFrom`);
    this.props.clearFormInput(`${compName}DateTo`);
    this.props.clearFormInput(`${compName}AdjustmentOptions`);
    this.props.clearFormInput(`${compName}EmployeeName`)

    this.setState(pState => {
      return {
        ...pState,
        activePage: 1,
        orderBy: 'DESC',
        sortBy: 'CreatedDate'
      };
    }, () => this.getSafeManagements());
  }

  changePage = (e) => {
    this.resetPagination(e);
    this.getSafeManagements(e);
  }

  resetPagination = (page) => {
    this.setState({ activePage: page ? page : 1 });
  }

  downloadReport = () => {
    let branch = this.props.branchId || 0;
    let datefrom = this.props.datefrom || null;
    let dateto = this.props.dateto || null;
    let type = this.props.type || 0;
    this.props.getCsvReport(`reports/excel/safeManagement?branch=${branch}&type=${type}&dateFrom=${datefrom}&dateTo=${dateto}`, "safeManagement");
  }

  render() {
    return (
      <Grid headerContent={safeManageMentListCrumb} >
        <PageHeaderWithButton title={LOOKUP.menu.admin.items.safemanagement.text}>
          <Button primary={true}
            type="AddButton"
            mini={true}
            className="bg-light-green"
            label={LOOKUP.safemanagement.controls.addNewButton}
            onTouchTap={this.addSafeManagement} />
        </PageHeaderWithButton>
        <CardSimple className="p-1">
          <SearchFields
            downloadReport={this.downloadReport}
            pageName={compName}
            cleanSearch={this.cleanSearch}
            search={this.search}
          />
        </CardSimple>
        <CardSimple>
          <div className="p-2">
            Current Balance : ${this.props.safeManagement && this.props.safeManagement.balance.toLocaleString('en-US')}
          </div>
          <GenericTable
            compName="safeManagementTable"
            columns={LOOKUP.safemanagement.tableColumns}
            rows={mapSafeManagement(this.props.safeManagement ? this.props.safeManagement.items : [])}
            stripedRows={true}
          />
          <Pagination
            length={this.props.safeManagement ? this.props.safeManagement.totalItems : 0}
            itemsPerPage={this.state.itemsPerPage}
            activePage={this.state.activePage}
            onPageChange={this.changePage}
            maxButtons={2}
          />
        </CardSimple>
      </Grid>
    );
  }
}

function mapStatetoProps(state) {
  return {
    datefrom: state.form[`${compName}DateFrom`] ? moment(state.form[`${compName}DateFrom`]).format('YYYY-MM-DD') : null,
    dateto: state.form[`${compName}DateTo`] ? moment(state.form[`${compName}DateTo`]).format('YYYY-MM-DD') : null,
    employee: state.form[`${compName}EmployeeName`] != null ? state.form[`${compName}EmployeeName`] : null,
    type: state.form[`${compName}AdjustmentOptions`] != null ? state.form[`${compName}AdjustmentOptions`] : 0,
    branchId: state.common.branchId,
    safeManagement: state.entity.safeManagement ? state.entity.safeManagement : null
  };
}

function mapDispatchToProps(dispatch) {
  return {
    formInput: (value, name) => dispatch(formInput(value, name)),
    clearFormInput: (name) => dispatch(clearFormInput(name)),
    getCsvReport: (url, name) => dispatch(getCsvReport(url, name)),
    getSafeManagements: (model) => dispatch(getSafeManagements(model))
  };
}

export default connect(mapStatetoProps, mapDispatchToProps)(SafeManagementList);
